/* tslint:disable */
/* eslint-disable */
/**
 * Access Control API
 * API for managing users, roles, tenants, and features.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@digiwedge.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from './common.js';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap, } from './base.js';
export const CreatePermissionAssignmentDtoSubjectTypeEnum = {
    User: 'USER',
    Role: 'ROLE',
    Tenant: 'TENANT',
};
/**
 * ConsentsApi - axios parameter creator
 * @export
 */
export const ConsentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create or request consent for a user
         * @param {CreateConsentDto} createConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerCreate: async (createConsentDto, options = {}) => {
            // verify required parameter 'createConsentDto' is not null or undefined
            assertParamExists('consentsControllerCreate', 'createConsentDto', createConsentDto);
            const localVarPath = `/api/consents/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createConsentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Revoke consent for a user
         * @param {RevokeConsentDto} revokeConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerRevoke: async (revokeConsentDto, options = {}) => {
            // verify required parameter 'revokeConsentDto' is not null or undefined
            assertParamExists('consentsControllerRevoke', 'revokeConsentDto', revokeConsentDto);
            const localVarPath = `/api/consents/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(revokeConsentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing consent record
         * @param {UpdateConsentDto} updateConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerUpdate: async (updateConsentDto, options = {}) => {
            // verify required parameter 'updateConsentDto' is not null or undefined
            assertParamExists('consentsControllerUpdate', 'updateConsentDto', updateConsentDto);
            const localVarPath = `/api/consents/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateConsentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ConsentsApi - functional programming interface
 * @export
 */
export const ConsentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConsentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create or request consent for a user
         * @param {CreateConsentDto} createConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerCreate(createConsentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerCreate(createConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerCreate']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Revoke consent for a user
         * @param {RevokeConsentDto} revokeConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerRevoke(revokeConsentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerRevoke(revokeConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerRevoke']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing consent record
         * @param {UpdateConsentDto} updateConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerUpdate(updateConsentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerUpdate(updateConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerUpdate']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ConsentsApi - factory interface
 * @export
 */
export const ConsentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConsentsApiFp(configuration);
    return {
        /**
         *
         * @summary Create or request consent for a user
         * @param {CreateConsentDto} createConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerCreate(createConsentDto, options) {
            return localVarFp
                .consentsControllerCreate(createConsentDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Revoke consent for a user
         * @param {RevokeConsentDto} revokeConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerRevoke(revokeConsentDto, options) {
            return localVarFp
                .consentsControllerRevoke(revokeConsentDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing consent record
         * @param {UpdateConsentDto} updateConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerUpdate(updateConsentDto, options) {
            return localVarFp
                .consentsControllerUpdate(updateConsentDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConsentsApi - object-oriented interface
 * @export
 * @class ConsentsApi
 * @extends {BaseAPI}
 */
export class ConsentsApi extends BaseAPI {
    /**
     *
     * @summary Create or request consent for a user
     * @param {CreateConsentDto} createConsentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerCreate(createConsentDto, options) {
        return ConsentsApiFp(this.configuration)
            .consentsControllerCreate(createConsentDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Revoke consent for a user
     * @param {RevokeConsentDto} revokeConsentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerRevoke(revokeConsentDto, options) {
        return ConsentsApiFp(this.configuration)
            .consentsControllerRevoke(revokeConsentDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing consent record
     * @param {UpdateConsentDto} updateConsentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerUpdate(updateConsentDto, options) {
        return ConsentsApiFp(this.configuration)
            .consentsControllerUpdate(updateConsentDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeatureFlagsApi - axios parameter creator
 * @export
 */
export const FeatureFlagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new FeatureFlag (link feature to user/role/tenant)
         * @param {CreateFeatureFlagDto} createFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerCreateFeatureFlag: async (createFeatureFlagDto, options = {}) => {
            // verify required parameter 'createFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerCreateFeatureFlag', 'createFeatureFlagDto', createFeatureFlagDto);
            const localVarPath = `/api/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createFeatureFlagDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a FeatureFlag by its ID
         * @param {string} id FeatureFlag ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerGetFeatureFlagById', 'id', id);
            const localVarPath = `/api/feature-flags/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List FeatureFlags by enabled=true/false
         * @param {boolean} enabled Whether to filter by enabled&#x3D;true or enabled&#x3D;false.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagsByEnabledState: async (enabled, skip, take, options = {}) => {
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('featureFlagsControllerGetFeatureFlagsByEnabledState', 'enabled', enabled);
            const localVarPath = `/api/feature-flags/enabled-state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List FeatureFlags by userId, roleId, or tenantId
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {string} [userId] User ID to filter FeatureFlags by.
         * @param {string} [roleId] Role ID to filter FeatureFlags by.
         * @param {string} [tenantId] Tenant ID to filter FeatureFlags by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagsByEntity: async (skip, take, userId, roleId, tenantId, options = {}) => {
            const localVarPath = `/api/feature-flags/by-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List FeatureFlags by featureId
         * @param {string} featureId The feature ID to filter by.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagsByFeature: async (featureId, skip, take, options = {}) => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('featureFlagsControllerGetFeatureFlagsByFeature', 'featureId', featureId);
            const localVarPath = `/api/feature-flags/by-feature/{featureId}`.replace(`{${'featureId'}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve non-deleted FeatureFlags (optional pagination)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetNonDeletedFeatureFlags: async (skip, take, options = {}) => {
            const localVarPath = `/api/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerPermanentlyDeleteFeatureFlag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerPermanentlyDeleteFeatureFlag', 'id', id);
            const localVarPath = `/api/feature-flags/{id}/permanent`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerRestoreFeatureFlag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerRestoreFeatureFlag', 'id', id);
            const localVarPath = `/api/feature-flags/{id}/restore`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft-delete a FeatureFlag by ID
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerSoftDeleteFeatureFlag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerSoftDeleteFeatureFlag', 'id', id);
            const localVarPath = `/api/feature-flags/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing FeatureFlag (e.g., enablement)
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateFeatureFlag: async (updateFeatureFlagDto, options = {}) => {
            // verify required parameter 'updateFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateFeatureFlag', 'updateFeatureFlagDto', updateFeatureFlagDto);
            const localVarPath = `/api/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureFlagDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FeatureFlagsApi - functional programming interface
 * @export
 */
export const FeatureFlagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeatureFlagsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new FeatureFlag (link feature to user/role/tenant)
         * @param {CreateFeatureFlagDto} createFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerCreateFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a FeatureFlag by its ID
         * @param {string} id FeatureFlag ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerGetFeatureFlagById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerGetFeatureFlagById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerGetFeatureFlagById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List FeatureFlags by enabled=true/false
         * @param {boolean} enabled Whether to filter by enabled&#x3D;true or enabled&#x3D;false.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerGetFeatureFlagsByEnabledState(enabled, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerGetFeatureFlagsByEnabledState(enabled, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerGetFeatureFlagsByEnabledState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List FeatureFlags by userId, roleId, or tenantId
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {string} [userId] User ID to filter FeatureFlags by.
         * @param {string} [roleId] Role ID to filter FeatureFlags by.
         * @param {string} [tenantId] Tenant ID to filter FeatureFlags by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerGetFeatureFlagsByEntity(skip, take, userId, roleId, tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerGetFeatureFlagsByEntity(skip, take, userId, roleId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerGetFeatureFlagsByEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List FeatureFlags by featureId
         * @param {string} featureId The feature ID to filter by.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerGetFeatureFlagsByFeature(featureId, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerGetFeatureFlagsByFeature(featureId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerGetFeatureFlagsByFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve non-deleted FeatureFlags (optional pagination)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerGetNonDeletedFeatureFlags(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerGetNonDeletedFeatureFlags(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerGetNonDeletedFeatureFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerPermanentlyDeleteFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerRestoreFeatureFlag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerRestoreFeatureFlag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerRestoreFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft-delete a FeatureFlag by ID
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerSoftDeleteFeatureFlag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerSoftDeleteFeatureFlag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerSoftDeleteFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing FeatureFlag (e.g., enablement)
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerUpdateFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FeatureFlagsApi - factory interface
 * @export
 */
export const FeatureFlagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeatureFlagsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new FeatureFlag (link feature to user/role/tenant)
         * @param {CreateFeatureFlagDto} createFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options) {
            return localVarFp
                .featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a FeatureFlag by its ID
         * @param {string} id FeatureFlag ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagById(id, options) {
            return localVarFp
                .featureFlagsControllerGetFeatureFlagById(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List FeatureFlags by enabled=true/false
         * @param {boolean} enabled Whether to filter by enabled&#x3D;true or enabled&#x3D;false.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagsByEnabledState(enabled, skip, take, options) {
            return localVarFp
                .featureFlagsControllerGetFeatureFlagsByEnabledState(enabled, skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List FeatureFlags by userId, roleId, or tenantId
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {string} [userId] User ID to filter FeatureFlags by.
         * @param {string} [roleId] Role ID to filter FeatureFlags by.
         * @param {string} [tenantId] Tenant ID to filter FeatureFlags by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagsByEntity(skip, take, userId, roleId, tenantId, options) {
            return localVarFp
                .featureFlagsControllerGetFeatureFlagsByEntity(skip, take, userId, roleId, tenantId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List FeatureFlags by featureId
         * @param {string} featureId The feature ID to filter by.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetFeatureFlagsByFeature(featureId, skip, take, options) {
            return localVarFp
                .featureFlagsControllerGetFeatureFlagsByFeature(featureId, skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve non-deleted FeatureFlags (optional pagination)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerGetNonDeletedFeatureFlags(skip, take, options) {
            return localVarFp
                .featureFlagsControllerGetNonDeletedFeatureFlags(skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options) {
            return localVarFp
                .featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerRestoreFeatureFlag(id, options) {
            return localVarFp
                .featureFlagsControllerRestoreFeatureFlag(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft-delete a FeatureFlag by ID
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerSoftDeleteFeatureFlag(id, options) {
            return localVarFp
                .featureFlagsControllerSoftDeleteFeatureFlag(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing FeatureFlag (e.g., enablement)
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options) {
            return localVarFp
                .featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeatureFlagsApi - object-oriented interface
 * @export
 * @class FeatureFlagsApi
 * @extends {BaseAPI}
 */
export class FeatureFlagsApi extends BaseAPI {
    /**
     *
     * @summary Create a new FeatureFlag (link feature to user/role/tenant)
     * @param {CreateFeatureFlagDto} createFeatureFlagDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a FeatureFlag by its ID
     * @param {string} id FeatureFlag ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerGetFeatureFlagById(id, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerGetFeatureFlagById(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List FeatureFlags by enabled=true/false
     * @param {boolean} enabled Whether to filter by enabled&#x3D;true or enabled&#x3D;false.
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take (max 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerGetFeatureFlagsByEnabledState(enabled, skip, take, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerGetFeatureFlagsByEnabledState(enabled, skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List FeatureFlags by userId, roleId, or tenantId
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take (max 50)
     * @param {string} [userId] User ID to filter FeatureFlags by.
     * @param {string} [roleId] Role ID to filter FeatureFlags by.
     * @param {string} [tenantId] Tenant ID to filter FeatureFlags by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerGetFeatureFlagsByEntity(skip, take, userId, roleId, tenantId, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerGetFeatureFlagsByEntity(skip, take, userId, roleId, tenantId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List FeatureFlags by featureId
     * @param {string} featureId The feature ID to filter by.
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take (max 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerGetFeatureFlagsByFeature(featureId, skip, take, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerGetFeatureFlagsByFeature(featureId, skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve non-deleted FeatureFlags (optional pagination)
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take (max 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerGetNonDeletedFeatureFlags(skip, take, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerGetNonDeletedFeatureFlags(skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a FeatureFlag
     * @param {string} id FeatureFlag ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted FeatureFlag
     * @param {string} id FeatureFlag ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerRestoreFeatureFlag(id, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerRestoreFeatureFlag(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft-delete a FeatureFlag by ID
     * @param {string} id FeatureFlag ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerSoftDeleteFeatureFlag(id, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerSoftDeleteFeatureFlag(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing FeatureFlag (e.g., enablement)
     * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options) {
        return FeatureFlagsApiFp(this.configuration)
            .featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeatureStatsApi - axios parameter creator
 * @export
 */
export const FeatureStatsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieve feature usage statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureStatsControllerGetFeatureUsageStats: async (options = {}) => {
            const localVarPath = `/api/features/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FeatureStatsApi - functional programming interface
 * @export
 */
export const FeatureStatsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeatureStatsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Retrieve feature usage statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureStatsControllerGetFeatureUsageStats(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureStatsControllerGetFeatureUsageStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureStatsApi.featureStatsControllerGetFeatureUsageStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FeatureStatsApi - factory interface
 * @export
 */
export const FeatureStatsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeatureStatsApiFp(configuration);
    return {
        /**
         *
         * @summary Retrieve feature usage statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureStatsControllerGetFeatureUsageStats(options) {
            return localVarFp
                .featureStatsControllerGetFeatureUsageStats(options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeatureStatsApi - object-oriented interface
 * @export
 * @class FeatureStatsApi
 * @extends {BaseAPI}
 */
export class FeatureStatsApi extends BaseAPI {
    /**
     *
     * @summary Retrieve feature usage statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureStatsApi
     */
    featureStatsControllerGetFeatureUsageStats(options) {
        return FeatureStatsApiFp(this.configuration)
            .featureStatsControllerGetFeatureUsageStats(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new feature
         * @param {CreateFeatureDto} createFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerCreateFeature: async (createFeatureDto, options = {}) => {
            // verify required parameter 'createFeatureDto' is not null or undefined
            assertParamExists('featuresControllerCreateFeature', 'createFeatureDto', createFeatureDto);
            const localVarPath = `/api/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createFeatureDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all features with optional filters
         * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
         * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
         * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
         * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerGetAllFeatures: async (enabled, includeDeleted, skip, take, options = {}) => {
            const localVarPath = `/api/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a feature by ID
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerGetFeatureById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerGetFeatureById', 'id', id);
            const localVarPath = `/api/features/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve multiple features by IDs
         * @param {Array<string>} ids List of feature IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerListFeaturesByIds: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('featuresControllerListFeaturesByIds', 'ids', ids);
            const localVarPath = `/api/features/list-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerPermanentlyDeleteFeature: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerPermanentlyDeleteFeature', 'id', id);
            const localVarPath = `/api/features/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerRestoreFeature: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerRestoreFeature', 'id', id);
            const localVarPath = `/api/features/{id}/restore`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerSoftDeleteFeature: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerSoftDeleteFeature', 'id', id);
            const localVarPath = `/api/features/{id}/soft-delete`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Toggle the enabled state of a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerToggleFeatureState: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerToggleFeatureState', 'id', id);
            const localVarPath = `/api/features/{id}/toggle`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing feature
         * @param {string} id Feature ID
         * @param {UpdateFeatureDto} updateFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerUpdateFeature: async (id, updateFeatureDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerUpdateFeature', 'id', id);
            // verify required parameter 'updateFeatureDto' is not null or undefined
            assertParamExists('featuresControllerUpdateFeature', 'updateFeatureDto', updateFeatureDto);
            const localVarPath = `/api/features/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new feature
         * @param {CreateFeatureDto} createFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerCreateFeature(createFeatureDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerCreateFeature(createFeatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerCreateFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all features with optional filters
         * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
         * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
         * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
         * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerGetAllFeatures(enabled, includeDeleted, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerGetAllFeatures(enabled, includeDeleted, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerGetAllFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a feature by ID
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerGetFeatureById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerGetFeatureById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerGetFeatureById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve multiple features by IDs
         * @param {Array<string>} ids List of feature IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerListFeaturesByIds(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerListFeaturesByIds(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerListFeaturesByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerPermanentlyDeleteFeature(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerPermanentlyDeleteFeature(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerPermanentlyDeleteFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerRestoreFeature(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerRestoreFeature(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerRestoreFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerSoftDeleteFeature(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerSoftDeleteFeature(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerSoftDeleteFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Toggle the enabled state of a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerToggleFeatureState(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerToggleFeatureState(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerToggleFeatureState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing feature
         * @param {string} id Feature ID
         * @param {UpdateFeatureDto} updateFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerUpdateFeature(id, updateFeatureDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerUpdateFeature(id, updateFeatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerUpdateFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeaturesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new feature
         * @param {CreateFeatureDto} createFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerCreateFeature(createFeatureDto, options) {
            return localVarFp
                .featuresControllerCreateFeature(createFeatureDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all features with optional filters
         * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
         * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
         * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
         * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerGetAllFeatures(enabled, includeDeleted, skip, take, options) {
            return localVarFp
                .featuresControllerGetAllFeatures(enabled, includeDeleted, skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a feature by ID
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerGetFeatureById(id, options) {
            return localVarFp
                .featuresControllerGetFeatureById(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve multiple features by IDs
         * @param {Array<string>} ids List of feature IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerListFeaturesByIds(ids, options) {
            return localVarFp
                .featuresControllerListFeaturesByIds(ids, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerPermanentlyDeleteFeature(id, options) {
            return localVarFp
                .featuresControllerPermanentlyDeleteFeature(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerRestoreFeature(id, options) {
            return localVarFp
                .featuresControllerRestoreFeature(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerSoftDeleteFeature(id, options) {
            return localVarFp
                .featuresControllerSoftDeleteFeature(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Toggle the enabled state of a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerToggleFeatureState(id, options) {
            return localVarFp
                .featuresControllerToggleFeatureState(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing feature
         * @param {string} id Feature ID
         * @param {UpdateFeatureDto} updateFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerUpdateFeature(id, updateFeatureDto, options) {
            return localVarFp
                .featuresControllerUpdateFeature(id, updateFeatureDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     *
     * @summary Create a new feature
     * @param {CreateFeatureDto} createFeatureDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerCreateFeature(createFeatureDto, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerCreateFeature(createFeatureDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all features with optional filters
     * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
     * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
     * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
     * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerGetAllFeatures(enabled, includeDeleted, skip, take, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerGetAllFeatures(enabled, includeDeleted, skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a feature by ID
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerGetFeatureById(id, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerGetFeatureById(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve multiple features by IDs
     * @param {Array<string>} ids List of feature IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerListFeaturesByIds(ids, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerListFeaturesByIds(ids, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerPermanentlyDeleteFeature(id, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerPermanentlyDeleteFeature(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerRestoreFeature(id, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerRestoreFeature(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerSoftDeleteFeature(id, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerSoftDeleteFeature(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Toggle the enabled state of a feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerToggleFeatureState(id, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerToggleFeatureState(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing feature
     * @param {string} id Feature ID
     * @param {UpdateFeatureDto} updateFeatureDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerUpdateFeature(id, updateFeatureDto, options) {
        return FeaturesApiFp(this.configuration)
            .featuresControllerUpdateFeature(id, updateFeatureDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck: async (options = {}) => {
            const localVarPath = `/api/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerCheck(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck(options) {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerCheck(options) {
        return HealthApiFp(this.configuration)
            .healthControllerCheck(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LoginAttemptsApi - axios parameter creator
 * @export
 */
export const LoginAttemptsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Bulk create multiple login attempts in one request.
         * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateBulkLoginAttempts: async (bulkCreateLoginAttemptsDto, options = {}) => {
            // verify required parameter 'bulkCreateLoginAttemptsDto' is not null or undefined
            assertParamExists('loginAttemptsControllerCreateBulkLoginAttempts', 'bulkCreateLoginAttemptsDto', bulkCreateLoginAttemptsDto);
            const localVarPath = `/api/login-attempts/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateLoginAttemptsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new login attempt record.
         * @param {CreateLoginAttemptDto} createLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateLoginAttempt: async (createLoginAttemptDto, options = {}) => {
            // verify required parameter 'createLoginAttemptDto' is not null or undefined
            assertParamExists('loginAttemptsControllerCreateLoginAttempt', 'createLoginAttemptDto', createLoginAttemptDto);
            const localVarPath = `/api/login-attempts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createLoginAttemptDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete all login attempts older than a certain date/time.
         * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerDeleteOldLoginAttempts: async (deleteOldLoginAttemptsDto, options = {}) => {
            // verify required parameter 'deleteOldLoginAttemptsDto' is not null or undefined
            assertParamExists('loginAttemptsControllerDeleteOldLoginAttempts', 'deleteOldLoginAttemptsDto', deleteOldLoginAttemptsDto);
            const localVarPath = `/api/login-attempts/delete-old`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(deleteOldLoginAttemptsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a login attempt by its ID.
         * @param {string} id LoginAttempt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttemptById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loginAttemptsControllerGetLoginAttemptById', 'id', id);
            const localVarPath = `/api/login-attempts/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve multiple login attempts with optional filters.
         * @param {number} [skip] Number of records to skip.
         * @param {number} [take] Number of records to take.
         * @param {string} [userId] Filter by userId.
         * @param {string} [tenantId] Filter by tenantId.
         * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
         * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttempts: async (skip, take, userId, tenantId, success, fromDate, toDate, options = {}) => {
            const localVarPath = `/api/login-attempts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (success !== undefined) {
                localVarQueryParameter['success'] = success;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a login attempt.
         * @param {string} id The ID of the login attempt to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerPermanentlyDeleteLoginAttempt: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loginAttemptsControllerPermanentlyDeleteLoginAttempt', 'id', id);
            const localVarPath = `/api/login-attempts/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing login attempt record.
         * @param {string} id The ID of the login attempt to update.
         * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerUpdateLoginAttempt: async (id, updateLoginAttemptDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loginAttemptsControllerUpdateLoginAttempt', 'id', id);
            // verify required parameter 'updateLoginAttemptDto' is not null or undefined
            assertParamExists('loginAttemptsControllerUpdateLoginAttempt', 'updateLoginAttemptDto', updateLoginAttemptDto);
            const localVarPath = `/api/login-attempts/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoginAttemptDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LoginAttemptsApi - functional programming interface
 * @export
 */
export const LoginAttemptsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LoginAttemptsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Bulk create multiple login attempts in one request.
         * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerCreateBulkLoginAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new login attempt record.
         * @param {CreateLoginAttemptDto} createLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerCreateLoginAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete all login attempts older than a certain date/time.
         * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerDeleteOldLoginAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a login attempt by its ID.
         * @param {string} id LoginAttempt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerGetLoginAttemptById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerGetLoginAttemptById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerGetLoginAttemptById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve multiple login attempts with optional filters.
         * @param {number} [skip] Number of records to skip.
         * @param {number} [take] Number of records to take.
         * @param {string} [userId] Filter by userId.
         * @param {string} [tenantId] Filter by tenantId.
         * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
         * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerGetLoginAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a login attempt.
         * @param {string} id The ID of the login attempt to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerPermanentlyDeleteLoginAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing login attempt record.
         * @param {string} id The ID of the login attempt to update.
         * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerUpdateLoginAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LoginAttemptsApi - factory interface
 * @export
 */
export const LoginAttemptsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LoginAttemptsApiFp(configuration);
    return {
        /**
         *
         * @summary Bulk create multiple login attempts in one request.
         * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options) {
            return localVarFp
                .loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new login attempt record.
         * @param {CreateLoginAttemptDto} createLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options) {
            return localVarFp
                .loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete all login attempts older than a certain date/time.
         * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options) {
            return localVarFp
                .loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a login attempt by its ID.
         * @param {string} id LoginAttempt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttemptById(id, options) {
            return localVarFp
                .loginAttemptsControllerGetLoginAttemptById(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve multiple login attempts with optional filters.
         * @param {number} [skip] Number of records to skip.
         * @param {number} [take] Number of records to take.
         * @param {string} [userId] Filter by userId.
         * @param {string} [tenantId] Filter by tenantId.
         * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
         * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options) {
            return localVarFp
                .loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a login attempt.
         * @param {string} id The ID of the login attempt to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options) {
            return localVarFp
                .loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing login attempt record.
         * @param {string} id The ID of the login attempt to update.
         * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options) {
            return localVarFp
                .loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * LoginAttemptsApi - object-oriented interface
 * @export
 * @class LoginAttemptsApi
 * @extends {BaseAPI}
 */
export class LoginAttemptsApi extends BaseAPI {
    /**
     *
     * @summary Bulk create multiple login attempts in one request.
     * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options) {
        return LoginAttemptsApiFp(this.configuration)
            .loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new login attempt record.
     * @param {CreateLoginAttemptDto} createLoginAttemptDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options) {
        return LoginAttemptsApiFp(this.configuration)
            .loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete all login attempts older than a certain date/time.
     * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options) {
        return LoginAttemptsApiFp(this.configuration)
            .loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a login attempt by its ID.
     * @param {string} id LoginAttempt ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerGetLoginAttemptById(id, options) {
        return LoginAttemptsApiFp(this.configuration)
            .loginAttemptsControllerGetLoginAttemptById(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve multiple login attempts with optional filters.
     * @param {number} [skip] Number of records to skip.
     * @param {number} [take] Number of records to take.
     * @param {string} [userId] Filter by userId.
     * @param {string} [tenantId] Filter by tenantId.
     * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
     * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
     * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options) {
        return LoginAttemptsApiFp(this.configuration)
            .loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a login attempt.
     * @param {string} id The ID of the login attempt to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options) {
        return LoginAttemptsApiFp(this.configuration)
            .loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing login attempt record.
     * @param {string} id The ID of the login attempt to update.
     * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options) {
        return LoginAttemptsApiFp(this.configuration)
            .loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PermissionAssignmentsApi - axios parameter creator
 * @export
 */
export const PermissionAssignmentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new PermissionAssignment record
         * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerCreateAssignment: async (createPermissionAssignmentDto, options = {}) => {
            // verify required parameter 'createPermissionAssignmentDto' is not null or undefined
            assertParamExists('permissionAssignmentsControllerCreateAssignment', 'createPermissionAssignmentDto', createPermissionAssignmentDto);
            const localVarPath = `/api/permission-assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createPermissionAssignmentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a PermissionAssignment by its ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerDeleteAssignment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionAssignmentsControllerDeleteAssignment', 'id', id);
            const localVarPath = `/api/permission-assignments/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a PermissionAssignment by its unique ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerGetAssignmentById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionAssignmentsControllerGetAssignmentById', 'id', id);
            const localVarPath = `/api/permission-assignments/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List PermissionAssignments with optional filters/pagination
         * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
         * @param {string} [subjectId] Filter by subjectId (UUID)
         * @param {string} [permissionId] Filter by permissionId (UUID)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerListAssignments: async (subjectType, subjectId, permissionId, skip, take, options = {}) => {
            const localVarPath = `/api/permission-assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (subjectType !== undefined) {
                localVarQueryParameter['subjectType'] = subjectType;
            }
            if (subjectId !== undefined) {
                localVarQueryParameter['subjectId'] = subjectId;
            }
            if (permissionId !== undefined) {
                localVarQueryParameter['permissionId'] = permissionId;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerUpdateAssignment: async (id, updatePermissionAssignmentDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionAssignmentsControllerUpdateAssignment', 'id', id);
            // verify required parameter 'updatePermissionAssignmentDto' is not null or undefined
            assertParamExists('permissionAssignmentsControllerUpdateAssignment', 'updatePermissionAssignmentDto', updatePermissionAssignmentDto);
            const localVarPath = `/api/permission-assignments/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePermissionAssignmentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PermissionAssignmentsApi - functional programming interface
 * @export
 */
export const PermissionAssignmentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PermissionAssignmentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new PermissionAssignment record
         * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerCreateAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a PermissionAssignment by its ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerDeleteAssignment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerDeleteAssignment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerDeleteAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a PermissionAssignment by its unique ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerGetAssignmentById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerGetAssignmentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerGetAssignmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List PermissionAssignments with optional filters/pagination
         * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
         * @param {string} [subjectId] Filter by subjectId (UUID)
         * @param {string} [permissionId] Filter by permissionId (UUID)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerListAssignments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerUpdateAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PermissionAssignmentsApi - factory interface
 * @export
 */
export const PermissionAssignmentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PermissionAssignmentsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new PermissionAssignment record
         * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options) {
            return localVarFp
                .permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a PermissionAssignment by its ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerDeleteAssignment(id, options) {
            return localVarFp
                .permissionAssignmentsControllerDeleteAssignment(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a PermissionAssignment by its unique ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerGetAssignmentById(id, options) {
            return localVarFp
                .permissionAssignmentsControllerGetAssignmentById(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List PermissionAssignments with optional filters/pagination
         * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
         * @param {string} [subjectId] Filter by subjectId (UUID)
         * @param {string} [permissionId] Filter by permissionId (UUID)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options) {
            return localVarFp
                .permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options) {
            return localVarFp
                .permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PermissionAssignmentsApi - object-oriented interface
 * @export
 * @class PermissionAssignmentsApi
 * @extends {BaseAPI}
 */
export class PermissionAssignmentsApi extends BaseAPI {
    /**
     *
     * @summary Create a new PermissionAssignment record
     * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options) {
        return PermissionAssignmentsApiFp(this.configuration)
            .permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a PermissionAssignment by its ID
     * @param {string} id PermissionAssignment ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerDeleteAssignment(id, options) {
        return PermissionAssignmentsApiFp(this.configuration)
            .permissionAssignmentsControllerDeleteAssignment(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a PermissionAssignment by its unique ID
     * @param {string} id PermissionAssignment ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerGetAssignmentById(id, options) {
        return PermissionAssignmentsApiFp(this.configuration)
            .permissionAssignmentsControllerGetAssignmentById(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List PermissionAssignments with optional filters/pagination
     * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
     * @param {string} [subjectId] Filter by subjectId (UUID)
     * @param {string} [permissionId] Filter by permissionId (UUID)
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options) {
        return PermissionAssignmentsApiFp(this.configuration)
            .permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
     * @param {string} id PermissionAssignment ID (UUID)
     * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options) {
        return PermissionAssignmentsApiFp(this.configuration)
            .permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new Permission record
         * @param {CreatePermissionDto} createPermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerCreatePermission: async (createPermissionDto, options = {}) => {
            // verify required parameter 'createPermissionDto' is not null or undefined
            assertParamExists('permissionsControllerCreatePermission', 'createPermissionDto', createPermissionDto);
            const localVarPath = `/api/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createPermissionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a Permission by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerDeletePermission: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionsControllerDeletePermission', 'id', id);
            const localVarPath = `/api/permissions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a Permission record by its featureId
         * @param {string} featureId Feature ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionByFeatureId: async (featureId, options = {}) => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('permissionsControllerGetPermissionByFeatureId', 'featureId', featureId);
            const localVarPath = `/api/permissions/by-feature/{featureId}`.replace(`{${'featureId'}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a Permission record by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionsControllerGetPermissionById', 'id', id);
            const localVarPath = `/api/permissions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List multiple Permission records, optionally filtered/paginated
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {string} [featureId] Optionally filter by featureId (UUID).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerListPermissions: async (skip, take, featureId, options = {}) => {
            const localVarPath = `/api/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (featureId !== undefined) {
                localVarQueryParameter['featureId'] = featureId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing Permission record
         * @param {string} id Permission ID (UUID)
         * @param {UpdatePermissionDto} updatePermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerUpdatePermission: async (id, updatePermissionDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionsControllerUpdatePermission', 'id', id);
            // verify required parameter 'updatePermissionDto' is not null or undefined
            assertParamExists('permissionsControllerUpdatePermission', 'updatePermissionDto', updatePermissionDto);
            const localVarPath = `/api/permissions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePermissionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new Permission record
         * @param {CreatePermissionDto} createPermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerCreatePermission(createPermissionDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerCreatePermission(createPermissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerCreatePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a Permission by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerDeletePermission(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerDeletePermission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerDeletePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a Permission record by its featureId
         * @param {string} featureId Feature ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerGetPermissionByFeatureId(featureId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerGetPermissionByFeatureId(featureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerGetPermissionByFeatureId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a Permission record by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerGetPermissionById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerGetPermissionById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerGetPermissionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List multiple Permission records, optionally filtered/paginated
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {string} [featureId] Optionally filter by featureId (UUID).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerListPermissions(skip, take, featureId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerListPermissions(skip, take, featureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerListPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing Permission record
         * @param {string} id Permission ID (UUID)
         * @param {UpdatePermissionDto} updatePermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerUpdatePermission(id, updatePermissionDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerUpdatePermission(id, updatePermissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerUpdatePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PermissionsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new Permission record
         * @param {CreatePermissionDto} createPermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerCreatePermission(createPermissionDto, options) {
            return localVarFp
                .permissionsControllerCreatePermission(createPermissionDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a Permission by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerDeletePermission(id, options) {
            return localVarFp
                .permissionsControllerDeletePermission(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a Permission record by its featureId
         * @param {string} featureId Feature ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionByFeatureId(featureId, options) {
            return localVarFp
                .permissionsControllerGetPermissionByFeatureId(featureId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a Permission record by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionById(id, options) {
            return localVarFp
                .permissionsControllerGetPermissionById(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List multiple Permission records, optionally filtered/paginated
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {string} [featureId] Optionally filter by featureId (UUID).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerListPermissions(skip, take, featureId, options) {
            return localVarFp
                .permissionsControllerListPermissions(skip, take, featureId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing Permission record
         * @param {string} id Permission ID (UUID)
         * @param {UpdatePermissionDto} updatePermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerUpdatePermission(id, updatePermissionDto, options) {
            return localVarFp
                .permissionsControllerUpdatePermission(id, updatePermissionDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     *
     * @summary Create a new Permission record
     * @param {CreatePermissionDto} createPermissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerCreatePermission(createPermissionDto, options) {
        return PermissionsApiFp(this.configuration)
            .permissionsControllerCreatePermission(createPermissionDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a Permission by its ID
     * @param {string} id Permission ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerDeletePermission(id, options) {
        return PermissionsApiFp(this.configuration)
            .permissionsControllerDeletePermission(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a Permission record by its featureId
     * @param {string} featureId Feature ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerGetPermissionByFeatureId(featureId, options) {
        return PermissionsApiFp(this.configuration)
            .permissionsControllerGetPermissionByFeatureId(featureId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a Permission record by its ID
     * @param {string} id Permission ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerGetPermissionById(id, options) {
        return PermissionsApiFp(this.configuration)
            .permissionsControllerGetPermissionById(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List multiple Permission records, optionally filtered/paginated
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take
     * @param {string} [featureId] Optionally filter by featureId (UUID).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerListPermissions(skip, take, featureId, options) {
        return PermissionsApiFp(this.configuration)
            .permissionsControllerListPermissions(skip, take, featureId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing Permission record
     * @param {string} id Permission ID (UUID)
     * @param {UpdatePermissionDto} updatePermissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerUpdatePermission(id, updatePermissionDto, options) {
        return PermissionsApiFp(this.configuration)
            .permissionsControllerUpdatePermission(id, updatePermissionDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new role
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerCreateRole: async (createRoleDto, options = {}) => {
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('rolesControllerCreateRole', 'createRoleDto', createRoleDto);
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all roles with optional pagination
         * @param {number} [skip] Records to skip (pagination). Default 0.
         * @param {number} [take] Records to take (max 50). Default 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerFindAllRoles: async (skip, take, options = {}) => {
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a role
         * @param {string} id The ID of the role to delete permanently
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerPermanentlyDeleteRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerPermanentlyDeleteRole', 'id', id);
            const localVarPath = `/api/roles/{id}/permanent`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted role
         * @param {string} id The ID of the role to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerRestoreRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerRestoreRole', 'id', id);
            const localVarPath = `/api/roles/{id}/restore`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a role
         * @param {string} id The ID of the role to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerSoftDeleteRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerSoftDeleteRole', 'id', id);
            const localVarPath = `/api/roles/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a role\'s details
         * @param {string} id The ID of the role to update
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerUpdateRole: async (id, updateRoleDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerUpdateRole', 'id', id);
            // verify required parameter 'updateRoleDto' is not null or undefined
            assertParamExists('rolesControllerUpdateRole', 'updateRoleDto', updateRoleDto);
            const localVarPath = `/api/roles/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new role
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerCreateRole(createRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerCreateRole(createRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerCreateRole']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all roles with optional pagination
         * @param {number} [skip] Records to skip (pagination). Default 0.
         * @param {number} [take] Records to take (max 50). Default 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerFindAllRoles(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerFindAllRoles(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerFindAllRoles']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a role
         * @param {string} id The ID of the role to delete permanently
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerPermanentlyDeleteRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerPermanentlyDeleteRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerPermanentlyDeleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted role
         * @param {string} id The ID of the role to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerRestoreRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerRestoreRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerRestoreRole']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a role
         * @param {string} id The ID of the role to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerSoftDeleteRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerSoftDeleteRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerSoftDeleteRole']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a role\'s details
         * @param {string} id The ID of the role to update
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerUpdateRole(id, updateRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerUpdateRole(id, updateRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerUpdateRole']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RolesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new role
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerCreateRole(createRoleDto, options) {
            return localVarFp
                .rolesControllerCreateRole(createRoleDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all roles with optional pagination
         * @param {number} [skip] Records to skip (pagination). Default 0.
         * @param {number} [take] Records to take (max 50). Default 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerFindAllRoles(skip, take, options) {
            return localVarFp
                .rolesControllerFindAllRoles(skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a role
         * @param {string} id The ID of the role to delete permanently
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerPermanentlyDeleteRole(id, options) {
            return localVarFp
                .rolesControllerPermanentlyDeleteRole(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted role
         * @param {string} id The ID of the role to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerRestoreRole(id, options) {
            return localVarFp
                .rolesControllerRestoreRole(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a role
         * @param {string} id The ID of the role to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerSoftDeleteRole(id, options) {
            return localVarFp
                .rolesControllerSoftDeleteRole(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a role\'s details
         * @param {string} id The ID of the role to update
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerUpdateRole(id, updateRoleDto, options) {
            return localVarFp
                .rolesControllerUpdateRole(id, updateRoleDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     *
     * @summary Create a new role
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerCreateRole(createRoleDto, options) {
        return RolesApiFp(this.configuration)
            .rolesControllerCreateRole(createRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all roles with optional pagination
     * @param {number} [skip] Records to skip (pagination). Default 0.
     * @param {number} [take] Records to take (max 50). Default 10.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerFindAllRoles(skip, take, options) {
        return RolesApiFp(this.configuration)
            .rolesControllerFindAllRoles(skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a role
     * @param {string} id The ID of the role to delete permanently
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerPermanentlyDeleteRole(id, options) {
        return RolesApiFp(this.configuration)
            .rolesControllerPermanentlyDeleteRole(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted role
     * @param {string} id The ID of the role to restore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerRestoreRole(id, options) {
        return RolesApiFp(this.configuration)
            .rolesControllerRestoreRole(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a role
     * @param {string} id The ID of the role to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerSoftDeleteRole(id, options) {
        return RolesApiFp(this.configuration)
            .rolesControllerSoftDeleteRole(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a role\'s details
     * @param {string} id The ID of the role to update
     * @param {UpdateRoleDto} updateRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerUpdateRole(id, updateRoleDto, options) {
        return RolesApiFp(this.configuration)
            .rolesControllerUpdateRole(id, updateRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieve all sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetAllSessionsByUserId: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sessionsControllerGetAllSessionsByUserId', 'userId', userId);
            const localVarPath = `/api/sessions/all/user/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a session by its unique ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionById: async (sessionId, options = {}) => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerGetSessionById', 'sessionId', sessionId);
            const localVarPath = `/api/sessions/{sessionId}`.replace(`{${'sessionId'}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a session by its unique jit
         * @param {string} token Session token (unique string).
         * @param {any} jit The session jit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionByToken: async (token, jit, options = {}) => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('sessionsControllerGetSessionByToken', 'token', token);
            // verify required parameter 'jit' is not null or undefined
            assertParamExists('sessionsControllerGetSessionByToken', 'jit', jit);
            const localVarPath = `/api/sessions/token/{jit}`
                .replace(`{${'token'}}`, encodeURIComponent(String(token)))
                .replace(`{${'jit'}}`, encodeURIComponent(String(jit)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all active sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionsByUserId: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sessionsControllerGetSessionsByUserId', 'userId', userId);
            const localVarPath = `/api/sessions/user/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Revoke a session by its token.
         * @param {string} token The session token to revoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerRevokeSession: async (token, options = {}) => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('sessionsControllerRevokeSession', 'token', token);
            const localVarPath = `/api/sessions/revoke/{token}`.replace(`{${'token'}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a session by its ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerSoftDeleteSession: async (sessionId, options = {}) => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerSoftDeleteSession', 'sessionId', sessionId);
            const localVarPath = `/api/sessions/{sessionId}`.replace(`{${'sessionId'}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SessionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Retrieve all sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetAllSessionsByUserId(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetAllSessionsByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetAllSessionsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a session by its unique ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionById(sessionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionById(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetSessionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a session by its unique jit
         * @param {string} token Session token (unique string).
         * @param {any} jit The session jit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionByToken(token, jit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionByToken(token, jit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetSessionByToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all active sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionsByUserId(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionsByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetSessionsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Revoke a session by its token.
         * @param {string} token The session token to revoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerRevokeSession(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerRevokeSession(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerRevokeSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a session by its ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerSoftDeleteSession(sessionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerSoftDeleteSession(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerSoftDeleteSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SessionsApiFp(configuration);
    return {
        /**
         *
         * @summary Retrieve all sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetAllSessionsByUserId(userId, options) {
            return localVarFp
                .sessionsControllerGetAllSessionsByUserId(userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a session by its unique ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionById(sessionId, options) {
            return localVarFp
                .sessionsControllerGetSessionById(sessionId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a session by its unique jit
         * @param {string} token Session token (unique string).
         * @param {any} jit The session jit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionByToken(token, jit, options) {
            return localVarFp
                .sessionsControllerGetSessionByToken(token, jit, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all active sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionsByUserId(userId, options) {
            return localVarFp
                .sessionsControllerGetSessionsByUserId(userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Revoke a session by its token.
         * @param {string} token The session token to revoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerRevokeSession(token, options) {
            return localVarFp
                .sessionsControllerRevokeSession(token, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a session by its ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerSoftDeleteSession(sessionId, options) {
            return localVarFp
                .sessionsControllerSoftDeleteSession(sessionId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
    /**
     *
     * @summary Retrieve all sessions for a user by their ID
     * @param {string} userId The user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetAllSessionsByUserId(userId, options) {
        return SessionsApiFp(this.configuration)
            .sessionsControllerGetAllSessionsByUserId(userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a session by its unique ID
     * @param {string} sessionId The session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetSessionById(sessionId, options) {
        return SessionsApiFp(this.configuration)
            .sessionsControllerGetSessionById(sessionId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a session by its unique jit
     * @param {string} token Session token (unique string).
     * @param {any} jit The session jit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetSessionByToken(token, jit, options) {
        return SessionsApiFp(this.configuration)
            .sessionsControllerGetSessionByToken(token, jit, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all active sessions for a user by their ID
     * @param {string} userId The user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetSessionsByUserId(userId, options) {
        return SessionsApiFp(this.configuration)
            .sessionsControllerGetSessionsByUserId(userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Revoke a session by its token.
     * @param {string} token The session token to revoke
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerRevokeSession(token, options) {
        return SessionsApiFp(this.configuration)
            .sessionsControllerRevokeSession(token, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a session by its ID
     * @param {string} sessionId The session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerSoftDeleteSession(sessionId, options) {
        return SessionsApiFp(this.configuration)
            .sessionsControllerSoftDeleteSession(sessionId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new tenant
         * @param {CreateTenantDto} createTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerCreateTenant: async (createTenantDto, options = {}) => {
            // verify required parameter 'createTenantDto' is not null or undefined
            assertParamExists('tenantsControllerCreateTenant', 'createTenantDto', createTenantDto);
            const localVarPath = `/api/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createTenantDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all tenants with optional pagination
         * @param {number} [skip] Number of records to skip
         * @param {number} [take] Number of records to take (max 1000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindAllTenants: async (skip, take, options = {}) => {
            const localVarPath = `/api/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a tenant by its ID
         * @param {string} tenantId The ID of the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindTenantById: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerFindTenantById', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a tenant
         * @param {string} tenantId The ID of the tenant to permanently delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerPermanentlyDeleteTenant: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerPermanentlyDeleteTenant', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}/permanent`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted tenant
         * @param {string} tenantId The ID of the tenant to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerRestoreTenant: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerRestoreTenant', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}/restore`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a tenant
         * @param {string} tenantId The ID of the tenant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerSoftDeleteTenant: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerSoftDeleteTenant', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a tenant\'s details
         * @param {string} tenantId The ID of the tenant to update
         * @param {UpdateTenantDto} updateTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerUpdateTenant: async (tenantId, updateTenantDto, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerUpdateTenant', 'tenantId', tenantId);
            // verify required parameter 'updateTenantDto' is not null or undefined
            assertParamExists('tenantsControllerUpdateTenant', 'updateTenantDto', updateTenantDto);
            const localVarPath = `/api/tenants/{tenantId}`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new tenant
         * @param {CreateTenantDto} createTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerCreateTenant(createTenantDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerCreateTenant(createTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerCreateTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all tenants with optional pagination
         * @param {number} [skip] Number of records to skip
         * @param {number} [take] Number of records to take (max 1000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerFindAllTenants(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerFindAllTenants(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerFindAllTenants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a tenant by its ID
         * @param {string} tenantId The ID of the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerFindTenantById(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerFindTenantById(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerFindTenantById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a tenant
         * @param {string} tenantId The ID of the tenant to permanently delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerPermanentlyDeleteTenant(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerPermanentlyDeleteTenant(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerPermanentlyDeleteTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted tenant
         * @param {string} tenantId The ID of the tenant to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerRestoreTenant(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerRestoreTenant(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerRestoreTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a tenant
         * @param {string} tenantId The ID of the tenant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerSoftDeleteTenant(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerSoftDeleteTenant(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerSoftDeleteTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a tenant\'s details
         * @param {string} tenantId The ID of the tenant to update
         * @param {UpdateTenantDto} updateTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerUpdateTenant(tenantId, updateTenantDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerUpdateTenant(tenantId, updateTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerUpdateTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TenantsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new tenant
         * @param {CreateTenantDto} createTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerCreateTenant(createTenantDto, options) {
            return localVarFp
                .tenantsControllerCreateTenant(createTenantDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all tenants with optional pagination
         * @param {number} [skip] Number of records to skip
         * @param {number} [take] Number of records to take (max 1000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindAllTenants(skip, take, options) {
            return localVarFp
                .tenantsControllerFindAllTenants(skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a tenant by its ID
         * @param {string} tenantId The ID of the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindTenantById(tenantId, options) {
            return localVarFp
                .tenantsControllerFindTenantById(tenantId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a tenant
         * @param {string} tenantId The ID of the tenant to permanently delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerPermanentlyDeleteTenant(tenantId, options) {
            return localVarFp
                .tenantsControllerPermanentlyDeleteTenant(tenantId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted tenant
         * @param {string} tenantId The ID of the tenant to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerRestoreTenant(tenantId, options) {
            return localVarFp
                .tenantsControllerRestoreTenant(tenantId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a tenant
         * @param {string} tenantId The ID of the tenant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerSoftDeleteTenant(tenantId, options) {
            return localVarFp
                .tenantsControllerSoftDeleteTenant(tenantId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a tenant\'s details
         * @param {string} tenantId The ID of the tenant to update
         * @param {UpdateTenantDto} updateTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerUpdateTenant(tenantId, updateTenantDto, options) {
            return localVarFp
                .tenantsControllerUpdateTenant(tenantId, updateTenantDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
    /**
     *
     * @summary Create a new tenant
     * @param {CreateTenantDto} createTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerCreateTenant(createTenantDto, options) {
        return TenantsApiFp(this.configuration)
            .tenantsControllerCreateTenant(createTenantDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all tenants with optional pagination
     * @param {number} [skip] Number of records to skip
     * @param {number} [take] Number of records to take (max 1000)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerFindAllTenants(skip, take, options) {
        return TenantsApiFp(this.configuration)
            .tenantsControllerFindAllTenants(skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a tenant by its ID
     * @param {string} tenantId The ID of the tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerFindTenantById(tenantId, options) {
        return TenantsApiFp(this.configuration)
            .tenantsControllerFindTenantById(tenantId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a tenant
     * @param {string} tenantId The ID of the tenant to permanently delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerPermanentlyDeleteTenant(tenantId, options) {
        return TenantsApiFp(this.configuration)
            .tenantsControllerPermanentlyDeleteTenant(tenantId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted tenant
     * @param {string} tenantId The ID of the tenant to restore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerRestoreTenant(tenantId, options) {
        return TenantsApiFp(this.configuration)
            .tenantsControllerRestoreTenant(tenantId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a tenant
     * @param {string} tenantId The ID of the tenant to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerSoftDeleteTenant(tenantId, options) {
        return TenantsApiFp(this.configuration)
            .tenantsControllerSoftDeleteTenant(tenantId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a tenant\'s details
     * @param {string} tenantId The ID of the tenant to update
     * @param {UpdateTenantDto} updateTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerUpdateTenant(tenantId, updateTenantDto, options) {
        return TenantsApiFp(this.configuration)
            .tenantsControllerUpdateTenant(tenantId, updateTenantDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserProfilesApi - axios parameter creator
 * @export
 */
export const UserProfilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Bulk restore user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerBulkRestoreProfiles: async (bulkProfileIdsDto, options = {}) => {
            // verify required parameter 'bulkProfileIdsDto' is not null or undefined
            assertParamExists('userProfilesControllerBulkRestoreProfiles', 'bulkProfileIdsDto', bulkProfileIdsDto);
            const localVarPath = `/api/user-profiles/bulk-restore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkProfileIdsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Bulk soft-delete user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerBulkSoftDeleteProfiles: async (bulkProfileIdsDto, options = {}) => {
            // verify required parameter 'bulkProfileIdsDto' is not null or undefined
            assertParamExists('userProfilesControllerBulkSoftDeleteProfiles', 'bulkProfileIdsDto', bulkProfileIdsDto);
            const localVarPath = `/api/user-profiles/bulk-soft-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkProfileIdsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new user profile
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfile: async (createUserProfileDto, options = {}) => {
            // verify required parameter 'createUserProfileDto' is not null or undefined
            assertParamExists('userProfilesControllerCreateUserProfile', 'createUserProfileDto', createUserProfileDto);
            const localVarPath = `/api/user-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createUserProfileDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new user profile with a duplicate check
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfileWithDuplicateCheck: async (createUserProfileDto, options = {}) => {
            // verify required parameter 'createUserProfileDto' is not null or undefined
            assertParamExists('userProfilesControllerCreateUserProfileWithDuplicateCheck', 'createUserProfileDto', createUserProfileDto);
            const localVarPath = `/api/user-profiles/duplicate-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createUserProfileDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all user profiles (paginated)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerGetAllUserProfiles: async (skip, take, options = {}) => {
            const localVarPath = `/api/user-profiles/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a user profile by its unique DB ID
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerGetUserProfileById: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesControllerGetUserProfileById', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}`.replace(`{${'profileId'}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a user profile by userId + provider
         * @param {string} userId User ID
         * @param {string} provider Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerGetUserProfileByUserAndProvider: async (userId, provider, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userProfilesControllerGetUserProfileByUserAndProvider', 'userId', userId);
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('userProfilesControllerGetUserProfileByUserAndProvider', 'provider', provider);
            const localVarPath = `/api/user-profiles/by-user-and-provider/{userId}/{provider}`
                .replace(`{${'userId'}}`, encodeURIComponent(String(userId)))
                .replace(`{${'provider'}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerPermanentlyDeleteUserProfile: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesControllerPermanentlyDeleteUserProfile', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}`.replace(`{${'profileId'}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerRestoreUserProfile: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesControllerRestoreUserProfile', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}/restore`.replace(`{${'profileId'}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerSoftDeleteUserProfile: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesControllerSoftDeleteUserProfile', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}/soft-delete`.replace(`{${'profileId'}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing user profile
         * @param {UpdateUserProfileDto} updateUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerUpdateUserProfile: async (updateUserProfileDto, options = {}) => {
            // verify required parameter 'updateUserProfileDto' is not null or undefined
            assertParamExists('userProfilesControllerUpdateUserProfile', 'updateUserProfileDto', updateUserProfileDto);
            const localVarPath = `/api/user-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserProfileDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserProfilesApi - functional programming interface
 * @export
 */
export const UserProfilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserProfilesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Bulk restore user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerBulkRestoreProfiles(bulkProfileIdsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerBulkRestoreProfiles(bulkProfileIdsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerBulkRestoreProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Bulk soft-delete user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerBulkSoftDeleteProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new user profile
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerCreateUserProfile(createUserProfileDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerCreateUserProfile(createUserProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerCreateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new user profile with a duplicate check
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerCreateUserProfileWithDuplicateCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all user profiles (paginated)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerGetAllUserProfiles(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerGetAllUserProfiles(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerGetAllUserProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a user profile by its unique DB ID
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerGetUserProfileById(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerGetUserProfileById(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerGetUserProfileById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a user profile by userId + provider
         * @param {string} userId User ID
         * @param {string} provider Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerGetUserProfileByUserAndProvider(userId, provider, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerGetUserProfileByUserAndProvider(userId, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerGetUserProfileByUserAndProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerPermanentlyDeleteUserProfile(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerPermanentlyDeleteUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerPermanentlyDeleteUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerRestoreUserProfile(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerRestoreUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerRestoreUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerSoftDeleteUserProfile(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerSoftDeleteUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerSoftDeleteUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing user profile
         * @param {UpdateUserProfileDto} updateUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerUpdateUserProfile(updateUserProfileDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerUpdateUserProfile(updateUserProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerUpdateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UserProfilesApi - factory interface
 * @export
 */
export const UserProfilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserProfilesApiFp(configuration);
    return {
        /**
         *
         * @summary Bulk restore user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerBulkRestoreProfiles(bulkProfileIdsDto, options) {
            return localVarFp
                .userProfilesControllerBulkRestoreProfiles(bulkProfileIdsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Bulk soft-delete user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options) {
            return localVarFp
                .userProfilesControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new user profile
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfile(createUserProfileDto, options) {
            return localVarFp
                .userProfilesControllerCreateUserProfile(createUserProfileDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new user profile with a duplicate check
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options) {
            return localVarFp
                .userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all user profiles (paginated)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerGetAllUserProfiles(skip, take, options) {
            return localVarFp
                .userProfilesControllerGetAllUserProfiles(skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a user profile by its unique DB ID
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerGetUserProfileById(profileId, options) {
            return localVarFp
                .userProfilesControllerGetUserProfileById(profileId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a user profile by userId + provider
         * @param {string} userId User ID
         * @param {string} provider Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerGetUserProfileByUserAndProvider(userId, provider, options) {
            return localVarFp
                .userProfilesControllerGetUserProfileByUserAndProvider(userId, provider, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerPermanentlyDeleteUserProfile(profileId, options) {
            return localVarFp
                .userProfilesControllerPermanentlyDeleteUserProfile(profileId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerRestoreUserProfile(profileId, options) {
            return localVarFp
                .userProfilesControllerRestoreUserProfile(profileId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerSoftDeleteUserProfile(profileId, options) {
            return localVarFp
                .userProfilesControllerSoftDeleteUserProfile(profileId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing user profile
         * @param {UpdateUserProfileDto} updateUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerUpdateUserProfile(updateUserProfileDto, options) {
            return localVarFp
                .userProfilesControllerUpdateUserProfile(updateUserProfileDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserProfilesApi - object-oriented interface
 * @export
 * @class UserProfilesApi
 * @extends {BaseAPI}
 */
export class UserProfilesApi extends BaseAPI {
    /**
     *
     * @summary Bulk restore user profiles
     * @param {BulkProfileIdsDto} bulkProfileIdsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerBulkRestoreProfiles(bulkProfileIdsDto, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerBulkRestoreProfiles(bulkProfileIdsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Bulk soft-delete user profiles
     * @param {BulkProfileIdsDto} bulkProfileIdsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new user profile
     * @param {CreateUserProfileDto} createUserProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerCreateUserProfile(createUserProfileDto, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerCreateUserProfile(createUserProfileDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new user profile with a duplicate check
     * @param {CreateUserProfileDto} createUserProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all user profiles (paginated)
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerGetAllUserProfiles(skip, take, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerGetAllUserProfiles(skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a user profile by its unique DB ID
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerGetUserProfileById(profileId, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerGetUserProfileById(profileId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a user profile by userId + provider
     * @param {string} userId User ID
     * @param {string} provider Provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerGetUserProfileByUserAndProvider(userId, provider, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerGetUserProfileByUserAndProvider(userId, provider, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a user profile
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerPermanentlyDeleteUserProfile(profileId, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerPermanentlyDeleteUserProfile(profileId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted user profile
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerRestoreUserProfile(profileId, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerRestoreUserProfile(profileId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a user profile
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerSoftDeleteUserProfile(profileId, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerSoftDeleteUserProfile(profileId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing user profile
     * @param {UpdateUserProfileDto} updateUserProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerUpdateUserProfile(updateUserProfileDto, options) {
        return UserProfilesApiFp(this.configuration)
            .userProfilesControllerUpdateUserProfile(updateUserProfileDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserRolesApi - axios parameter creator
 * @export
 */
export const UserRolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Assign a single role to a user
         * @param {AssignRoleToUserDto} assignRoleToUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerAssignRoleToUser: async (assignRoleToUserDto, options = {}) => {
            // verify required parameter 'assignRoleToUserDto' is not null or undefined
            assertParamExists('userRolesControllerAssignRoleToUser', 'assignRoleToUserDto', assignRoleToUserDto);
            const localVarPath = `/api/user-roles/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(assignRoleToUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Bulk assign multiple roles to a user
         * @param {BulkAssignRolesDto} bulkAssignRolesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerBulkAssignRolesToUser: async (bulkAssignRolesDto, options = {}) => {
            // verify required parameter 'bulkAssignRolesDto' is not null or undefined
            assertParamExists('userRolesControllerBulkAssignRolesToUser', 'bulkAssignRolesDto', bulkAssignRolesDto);
            const localVarPath = `/api/user-roles/bulk-assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAssignRolesDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove a role from a user by deleting the pivot record
         * @param {string} [pivotId] Pivot ID, if known
         * @param {string} [userId] User ID
         * @param {string} [roleId] Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerRemoveUserRole: async (pivotId, userId, roleId, options = {}) => {
            const localVarPath = `/api/user-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pivotId !== undefined) {
                localVarQueryParameter['pivotId'] = pivotId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a UserRole pivot record
         * @param {string} pivotId The ID of the UserRole pivot
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerUpdateUserRole: async (pivotId, updateUserRoleDto, options = {}) => {
            // verify required parameter 'pivotId' is not null or undefined
            assertParamExists('userRolesControllerUpdateUserRole', 'pivotId', pivotId);
            // verify required parameter 'updateUserRoleDto' is not null or undefined
            assertParamExists('userRolesControllerUpdateUserRole', 'updateUserRoleDto', updateUserRoleDto);
            const localVarPath = `/api/user-roles/{pivotId}`.replace(`{${'pivotId'}}`, encodeURIComponent(String(pivotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserRolesApi - functional programming interface
 * @export
 */
export const UserRolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserRolesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Assign a single role to a user
         * @param {AssignRoleToUserDto} assignRoleToUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerAssignRoleToUser(assignRoleToUserDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerAssignRoleToUser(assignRoleToUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerAssignRoleToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Bulk assign multiple roles to a user
         * @param {BulkAssignRolesDto} bulkAssignRolesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerBulkAssignRolesToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Remove a role from a user by deleting the pivot record
         * @param {string} [pivotId] Pivot ID, if known
         * @param {string} [userId] User ID
         * @param {string} [roleId] Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerRemoveUserRole(pivotId, userId, roleId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerRemoveUserRole(pivotId, userId, roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerRemoveUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a UserRole pivot record
         * @param {string} pivotId The ID of the UserRole pivot
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerUpdateUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UserRolesApi - factory interface
 * @export
 */
export const UserRolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserRolesApiFp(configuration);
    return {
        /**
         *
         * @summary Assign a single role to a user
         * @param {AssignRoleToUserDto} assignRoleToUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerAssignRoleToUser(assignRoleToUserDto, options) {
            return localVarFp
                .userRolesControllerAssignRoleToUser(assignRoleToUserDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Bulk assign multiple roles to a user
         * @param {BulkAssignRolesDto} bulkAssignRolesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options) {
            return localVarFp
                .userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a role from a user by deleting the pivot record
         * @param {string} [pivotId] Pivot ID, if known
         * @param {string} [userId] User ID
         * @param {string} [roleId] Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerRemoveUserRole(pivotId, userId, roleId, options) {
            return localVarFp
                .userRolesControllerRemoveUserRole(pivotId, userId, roleId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a UserRole pivot record
         * @param {string} pivotId The ID of the UserRole pivot
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options) {
            return localVarFp
                .userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserRolesApi - object-oriented interface
 * @export
 * @class UserRolesApi
 * @extends {BaseAPI}
 */
export class UserRolesApi extends BaseAPI {
    /**
     *
     * @summary Assign a single role to a user
     * @param {AssignRoleToUserDto} assignRoleToUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerAssignRoleToUser(assignRoleToUserDto, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesControllerAssignRoleToUser(assignRoleToUserDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Bulk assign multiple roles to a user
     * @param {BulkAssignRolesDto} bulkAssignRolesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a role from a user by deleting the pivot record
     * @param {string} [pivotId] Pivot ID, if known
     * @param {string} [userId] User ID
     * @param {string} [roleId] Role ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerRemoveUserRole(pivotId, userId, roleId, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesControllerRemoveUserRole(pivotId, userId, roleId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a UserRole pivot record
     * @param {string} pivotId The ID of the UserRole pivot
     * @param {UpdateUserRoleDto} updateUserRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Change a user\'s password
         * @param {any} userId User ID (UUID)
         * @param {ChangePasswordDto} changePasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangePassword: async (userId, changePasswordDto, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerChangePassword', 'userId', userId);
            // verify required parameter 'changePasswordDto' is not null or undefined
            assertParamExists('usersControllerChangePassword', 'changePasswordDto', changePasswordDto);
            const localVarPath = `/api/users/{userId}/password`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Change a user\'s role
         * @param {any} userId User ID (UUID)
         * @param {ChangeUserRoleDto} changeUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangeUserRole: async (userId, changeUserRoleDto, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerChangeUserRole', 'userId', userId);
            // verify required parameter 'changeUserRoleDto' is not null or undefined
            assertParamExists('usersControllerChangeUserRole', 'changeUserRoleDto', changeUserRoleDto);
            const localVarPath = `/api/users/{userId}/role`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(changeUserRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreateUser: async (createUserDto, options = {}) => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('usersControllerCreateUser', 'createUserDto', createUserDto);
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all users with optional pagination and filtering
         * @param {string} [email] Optional email filter to narrow down the user search.
         * @param {string} [role] Optional user role filter (e.g., \&quot;admin\&quot;, \&quot;user\&quot;).
         * @param {string} [tenantId] Tenant ID filter
         * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindAllUsers: async (email, role, tenantId, featureName, skip, take, options = {}) => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (featureName !== undefined) {
                localVarQueryParameter['featureName'] = featureName;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} email
         * @param {string} tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindUserByEmail: async (email, tenantId, options = {}) => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('usersControllerFindUserByEmail', 'email', email);
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('usersControllerFindUserByEmail', 'tenantId', tenantId);
            const localVarPath = `/api/users/by-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a user by their UserId
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserById: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerGetUserById', 'userId', userId);
            const localVarPath = `/api/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerPermanentlyDeleteUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerPermanentlyDeleteUser', 'userId', userId);
            const localVarPath = `/api/users/{userId}/permanent`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRestoreUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerRestoreUser', 'userId', userId);
            const localVarPath = `/api/users/{userId}/restore`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search for users based on filters and pagination
         * @param {string} [email] Email filter
         * @param {string} [role] Role filter
         * @param {string} [tenantId] Tenant ID filter
         * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSearchUsers: async (email, role, tenantId, featureName, skip, take, options = {}) => {
            const localVarPath = `/api/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (featureName !== undefined) {
                localVarQueryParameter['featureName'] = featureName;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSoftDeleteUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerSoftDeleteUser', 'userId', userId);
            const localVarPath = `/api/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update user details
         * @param {string} userId User ID (UUID)
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUser: async (userId, updateUserDto, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerUpdateUser', 'userId', userId);
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('usersControllerUpdateUser', 'updateUserDto', updateUserDto);
            const localVarPath = `/api/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Change a user\'s password
         * @param {any} userId User ID (UUID)
         * @param {ChangePasswordDto} changePasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerChangePassword(userId, changePasswordDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerChangePassword(userId, changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerChangePassword']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Change a user\'s role
         * @param {any} userId User ID (UUID)
         * @param {ChangeUserRoleDto} changeUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerChangeUserRole(userId, changeUserRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerChangeUserRole(userId, changeUserRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerChangeUserRole']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerCreateUser(createUserDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerCreateUser(createUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerCreateUser']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all users with optional pagination and filtering
         * @param {string} [email] Optional email filter to narrow down the user search.
         * @param {string} [role] Optional user role filter (e.g., \&quot;admin\&quot;, \&quot;user\&quot;).
         * @param {string} [tenantId] Tenant ID filter
         * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerFindAllUsers(email, role, tenantId, featureName, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerFindAllUsers(email, role, tenantId, featureName, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerFindAllUsers']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} email
         * @param {string} tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerFindUserByEmail(email, tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerFindUserByEmail(email, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerFindUserByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a user by their UserId
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetUserById(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetUserById(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetUserById']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerPermanentlyDeleteUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerPermanentlyDeleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerPermanentlyDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerRestoreUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerRestoreUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerRestoreUser']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search for users based on filters and pagination
         * @param {string} [email] Email filter
         * @param {string} [role] Role filter
         * @param {string} [tenantId] Tenant ID filter
         * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSearchUsers(email, role, tenantId, featureName, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSearchUsers(email, role, tenantId, featureName, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerSearchUsers']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSoftDeleteUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSoftDeleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerSoftDeleteUser']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update user details
         * @param {string} userId User ID (UUID)
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdateUser(userId, updateUserDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdateUser(userId, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerUpdateUser']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @summary Change a user\'s password
         * @param {any} userId User ID (UUID)
         * @param {ChangePasswordDto} changePasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangePassword(userId, changePasswordDto, options) {
            return localVarFp
                .usersControllerChangePassword(userId, changePasswordDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Change a user\'s role
         * @param {any} userId User ID (UUID)
         * @param {ChangeUserRoleDto} changeUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangeUserRole(userId, changeUserRoleDto, options) {
            return localVarFp
                .usersControllerChangeUserRole(userId, changeUserRoleDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreateUser(createUserDto, options) {
            return localVarFp
                .usersControllerCreateUser(createUserDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all users with optional pagination and filtering
         * @param {string} [email] Optional email filter to narrow down the user search.
         * @param {string} [role] Optional user role filter (e.g., \&quot;admin\&quot;, \&quot;user\&quot;).
         * @param {string} [tenantId] Tenant ID filter
         * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindAllUsers(email, role, tenantId, featureName, skip, take, options) {
            return localVarFp
                .usersControllerFindAllUsers(email, role, tenantId, featureName, skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {string} tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindUserByEmail(email, tenantId, options) {
            return localVarFp
                .usersControllerFindUserByEmail(email, tenantId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a user by their UserId
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserById(userId, options) {
            return localVarFp
                .usersControllerGetUserById(userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerPermanentlyDeleteUser(userId, options) {
            return localVarFp
                .usersControllerPermanentlyDeleteUser(userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRestoreUser(userId, options) {
            return localVarFp
                .usersControllerRestoreUser(userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search for users based on filters and pagination
         * @param {string} [email] Email filter
         * @param {string} [role] Role filter
         * @param {string} [tenantId] Tenant ID filter
         * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSearchUsers(email, role, tenantId, featureName, skip, take, options) {
            return localVarFp
                .usersControllerSearchUsers(email, role, tenantId, featureName, skip, take, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSoftDeleteUser(userId, options) {
            return localVarFp
                .usersControllerSoftDeleteUser(userId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user details
         * @param {string} userId User ID (UUID)
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUser(userId, updateUserDto, options) {
            return localVarFp
                .usersControllerUpdateUser(userId, updateUserDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @summary Change a user\'s password
     * @param {any} userId User ID (UUID)
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerChangePassword(userId, changePasswordDto, options) {
        return UsersApiFp(this.configuration)
            .usersControllerChangePassword(userId, changePasswordDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Change a user\'s role
     * @param {any} userId User ID (UUID)
     * @param {ChangeUserRoleDto} changeUserRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerChangeUserRole(userId, changeUserRoleDto, options) {
        return UsersApiFp(this.configuration)
            .usersControllerChangeUserRole(userId, changeUserRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new user
     * @param {CreateUserDto} createUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerCreateUser(createUserDto, options) {
        return UsersApiFp(this.configuration)
            .usersControllerCreateUser(createUserDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all users with optional pagination and filtering
     * @param {string} [email] Optional email filter to narrow down the user search.
     * @param {string} [role] Optional user role filter (e.g., \&quot;admin\&quot;, \&quot;user\&quot;).
     * @param {string} [tenantId] Tenant ID filter
     * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take (max 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerFindAllUsers(email, role, tenantId, featureName, skip, take, options) {
        return UsersApiFp(this.configuration)
            .usersControllerFindAllUsers(email, role, tenantId, featureName, skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {string} tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerFindUserByEmail(email, tenantId, options) {
        return UsersApiFp(this.configuration)
            .usersControllerFindUserByEmail(email, tenantId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a user by their UserId
     * @param {string} userId User ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerGetUserById(userId, options) {
        return UsersApiFp(this.configuration)
            .usersControllerGetUserById(userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a user
     * @param {string} userId User ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerPermanentlyDeleteUser(userId, options) {
        return UsersApiFp(this.configuration)
            .usersControllerPermanentlyDeleteUser(userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted user
     * @param {string} userId User ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerRestoreUser(userId, options) {
        return UsersApiFp(this.configuration)
            .usersControllerRestoreUser(userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search for users based on filters and pagination
     * @param {string} [email] Email filter
     * @param {string} [role] Role filter
     * @param {string} [tenantId] Tenant ID filter
     * @param {string} [featureName] Optional feature name filter. Only returns users associated with this feature.
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take (max 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerSearchUsers(email, role, tenantId, featureName, skip, take, options) {
        return UsersApiFp(this.configuration)
            .usersControllerSearchUsers(email, role, tenantId, featureName, skip, take, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a user
     * @param {string} userId User ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerSoftDeleteUser(userId, options) {
        return UsersApiFp(this.configuration)
            .usersControllerSoftDeleteUser(userId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user details
     * @param {string} userId User ID (UUID)
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerUpdateUser(userId, updateUserDto, options) {
        return UsersApiFp(this.configuration)
            .usersControllerUpdateUser(userId, updateUserDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map